import { useTheme, useMediaQuery } from '@mui/material';

const useMobile = (): boolean => {
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('md'));

  return mobileDevice;
};

export default useMobile;
